import React, { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const PersonIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <svg xmlns="http://www.w3.org/2000/svg" width="21.97" height="22.363" viewBox="0 0 21.97 22.363">
        <path
          d="M104.019 95.25a4.016 4.016 0 1 0 3.992 4.016 4.014 4.014 0 0 0-3.992-4.016zm0 1.66a2.356 2.356 0 1 1-2.323 2.356 2.33 2.33 0 0 1 2.323-2.356z"
          transform="translate(-93.036 -90.164)"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth=".2px"
        />
        <path
          d="M102.842 99.689a3.945 3.945 0 0 0-3.93 3.93v1.46a2.505 2.505 0 0 0 2.495 2.491h7.677a2.505 2.505 0 0 0 2.495-2.491v-1.46a3.945 3.945 0 0 0-3.93-3.93zm0 1.665h4.806a2.253 2.253 0 0 1 2.266 2.266v1.46a.817.817 0 0 1-.83.83h-7.677a.817.817 0 0 1-.83-.83v-1.46a2.253 2.253 0 0 1 2.265-2.266z"
          transform="translate(-94.26 -85.308)"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth=".2px"
        />
        <path
          d="M107.621 92.869a10.89 10.89 0 0 0-9.214 16.682.831.831 0 0 0 1.407-.883 9.225 9.225 0 1 1 15.619 0 .831.831 0 1 0 1.407.883 10.89 10.89 0 0 0-9.218-16.682z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth=".2px"
          transform="translate(-96.638 -92.769)"
        />
      </svg>
    </SvgIcon>
  );
});
